export const translations = {
  en: {
    nav: {
      about: "About",
      skills: "Skills",
      projects: "Projects",
      github: "GitHub",
      education: "Education",
      contact: "Contact",
    },
    sidebar: {
      openToOpportunities: "// open to opportunities",
      role: "Full Stack AI Developer",
      tagline:
        "I build AI-powered full-stack applications: interactive frontends, solid backends, RAG pipelines, and real-time systems.",
      location: "Casablanca, Morocco",
      downloadCV: "Download CV",
    },
    about: {
      title: "About",
      bio1: "I build AI-powered full-stack applications from interactive frontends with Next.js and Angular to backend services with Go, Java, and Spring Boot, integrating RAG pipelines and Claude Code.",
      bio2: "I care about clean code, performance, and real-time features, and I enjoy going low-level when a problem calls for it.",
      focusFullStackLabel: "Full Stack Web",
      focusFullStackDesc: "Next.js, Angular, Go, Spring-boot",
      focusAiLabel: "AI Integrations",
      focusAiDesc: "Claude Code, RAG pipelines",
      focusRealtimeLabel: "Real-Time Features",
      focusRealtimeDesc: "WebSockets, Kafka, event-driven",
      currently: "Currently",
      currently1: "Deepening backend architecture skills",
      currently2: "Building RAG pipelines with Claude Code",
      currently3: "Exploring cloud-native and DevOps tooling",
      statsProjects: "Projects built",
      statsTech: "Technologies",
      statsYears: "Years coding",
    },
    skills: {
      title: "Skills",
      subtitle: "Technologies I work with, collected from my projects",
      usedIn: (n) => `Used in ${n} project${n > 1 ? "s" : ""}`,
      categories: {
        Frontend: "Frontend",
        Backend: "Backend",
        Systems: "Systems",
        Database: "Database",
        APIs: "APIs",
        DevOps: "DevOps",
        Tools: "Tools",
        "Data Analytics": "Data Analytics",
        "AI & ML": "AI & ML",
        Other: "Other",
      },
    },
    projects: {
      title: "Projects",
      subtitle: (n) => `${n} projects across different domains`,
      noProjects: "No projects in this category.",
      liveDemo: "Live Demo",
      categories: {
        fullstack: "Full Stack",
        ai: "AI",
        frontend: "Frontend",
        backend: "Backend",
        lowlevel: "Low Level",
        tools: "Side Projects",
        piscine: "Piscine",
      },
    },
    github: {
      title: "GitHub Activity",
      repositories: "Repositories",
      totalStars: "Total Stars",
      totalForks: "Total Forks",
      followers: "Followers",
      topLanguages: "Top Languages",
      contributionGraph: "Contribution Graph",
      pinnedRepositories: "Pinned Repositories",
    },
    education: {
      title: "Education",
      program: "Full-Stack Software Engineering",
      location: "Oujda, Morocco",
      start: "Apr 2024",
      end: "Apr 2026",
      description:
        "Peer-to-peer, project-based training program covering full-stack development, low-level systems programming, software architecture, and AI. No lectures, no teachers, just projects and peer code reviews.",
    },
    contact: {
      title: "Get in touch",
      subtitle: "Open to new opportunities feel free to reach out.",
      footer: "© 2026 Amine Habchi built with React & Tailwind",
    },
  },

  fr: {
    nav: {
      about: "À propos",
      skills: "Compétences",
      projects: "Projets",
      github: "GitHub",
      education: "Formation",
      contact: "Contact",
    },
    sidebar: {
      openToOpportunities: "// ouvert aux opportunités",
      role: "Développeur Full Stack IA",
      tagline:
        "Je construis des applications full-stack propulsées par l'IA : interfaces interactives, backends solides, pipelines RAG et systèmes temps réel.",
      location: "Casablanca, Maroc",
      downloadCV: "Télécharger le CV",
    },
    about: {
      title: "À propos",
      bio1: "Je construis des applications full-stack propulsées par l'IA, des interfaces interactives avec Next.js et Angular jusqu'aux services backend avec Go, Java et Spring Boot, en intégrant des pipelines RAG et Claude Code.",
      bio2: "J'accorde une grande importance au code propre, à la performance et aux fonctionnalités temps réel, et j'aime descendre bas niveau quand un problème l'exige.",
      focusFullStackLabel: "Développement Full Stack",
      focusFullStackDesc: "Next.js, Angular, Go, Spring-boot",
      focusAiLabel: "Intégrations IA",
      focusAiDesc: "Claude Code, pipelines RAG",
      focusRealtimeLabel: "Temps réel",
      focusRealtimeDesc: "WebSockets, Kafka, événementiel",
      currently: "Actuellement",
      currently1: "Approfondissement de mes compétences en architecture backend",
      currently2: "Construction de pipelines RAG avec Claude Code",
      currently3: "Exploration des outils cloud-native et DevOps",
      statsProjects: "Projets réalisés",
      statsTech: "Technologies",
      statsYears: "Années de code",
    },
    skills: {
      title: "Compétences",
      subtitle: "Technologies que j'utilise, tirées de mes projets",
      usedIn: (n) => `Utilisé dans ${n} projet${n > 1 ? "s" : ""}`,
      categories: {
        Frontend: "Frontend",
        Backend: "Backend",
        Systems: "Systèmes",
        Database: "Base de données",
        APIs: "APIs",
        DevOps: "DevOps",
        Tools: "Outils",
        "Data Analytics": "Analyse de données",
        "AI & ML": "IA & ML",
        Other: "Autres",
      },
    },
    projects: {
      title: "Projets",
      subtitle: (n) => `${n} projets dans différents domaines`,
      noProjects: "Aucun projet dans cette catégorie.",
      liveDemo: "Démo en ligne",
      categories: {
        fullstack: "Full Stack",
        ai: "IA",
        frontend: "Frontend",
        backend: "Backend",
        lowlevel: "Bas niveau",
        tools: "Projets annexes",
        piscine: "Piscine",
      },
    },
    github: {
      title: "Activité GitHub",
      repositories: "Dépôts",
      totalStars: "Étoiles totales",
      totalForks: "Forks totaux",
      followers: "Abonnés",
      topLanguages: "Langages principaux",
      contributionGraph: "Graphique de contribution",
      pinnedRepositories: "Dépôts épinglés",
    },
    education: {
      title: "Formation",
      program: "Ingénierie logicielle Full-Stack",
      location: "Oujda, Maroc",
      start: "Avr 2024",
      end: "Avr 2026",
      description:
        "Formation en pair-à-pair, basée sur des projets, couvrant le développement full-stack, la programmation système bas niveau, l'architecture logicielle et l'IA. Pas de cours magistraux, pas de professeurs, juste des projets et des revues de code entre pairs.",
    },
    contact: {
      title: "Me contacter",
      subtitle: "Ouvert à de nouvelles opportunités, n'hésitez pas à me contacter.",
      footer: "© 2026 Amine Habchi conçu avec React & Tailwind",
    },
  },
};
